//@flow
import React from "react";

export default function ellipsis(text: string) {
  return (
    <div title={text} className="ellipsis flex-1">
      {text}
    </div>
  );
}
